'use es6';

import { useEffect } from 'react';
import { DuplicateIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { trackCompareToolInteraction } from 'EmailData/utils/tracking';
import CompareEmailsUpgradeButton from 'EmailComponents/compareEmails/CompareEmailsUpgradeButton';
import { getUsageTracker } from 'EmailComponents/utils/tracking';
import { COMPARISON_LIMIT } from 'email-management-lib/refactor/constants/comparison';
import ContentRoutes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MultiCompareEmailsLink({
  selectedEmailIds,
  hasComparisonToolAccess
}) {
  useEffect(() => {
    trackCompareToolInteraction(getUsageTracker(), {
      action: 'multi-select-entry-shown'
    });
  }, []);
  if (!hasComparisonToolAccess) {
    return /*#__PURE__*/_jsx(CompareEmailsUpgradeButton, {
      as: "link"
    });
  }
  return /*#__PURE__*/_jsxs(Link, {
    "data-test-id": "compare-emails-table-button",
    onClick: () => {
      const selectedIdsArray = selectedEmailIds.toArray();
      const limitedSelectedIds = selectedEmailIds.length > COMPARISON_LIMIT ? selectedIdsArray.slice(0, COMPARISON_LIMIT) : selectedIdsArray;
      trackCompareToolInteraction(getUsageTracker(), {
        action: 'multi-select-entry-clicked'
      });
      window.open(ContentRoutes.emailCompare(limitedSelectedIds));
    },
    children: [/*#__PURE__*/_jsx(DuplicateIcon, {}), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "email-management.header.compareEmails"
    })]
  });
}
export default MultiCompareEmailsLink;